import { render, staticRenderFns } from "./ModalAgrupador.vue?vue&type=template&id=66bca720"
import script from "./ModalAgrupador.vue?vue&type=script&lang=js"
export * from "./ModalAgrupador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66bca720')) {
      api.createRecord('66bca720', component.options)
    } else {
      api.reload('66bca720', component.options)
    }
    module.hot.accept("./ModalAgrupador.vue?vue&type=template&id=66bca720", function () {
      api.rerender('66bca720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalAgrupador.vue"
export default component.exports